import multiguard from 'vue-router-multiguard';
import { checkAuth } from '@/router/_auth';
import { checkBankType } from '@/router/individual/_type';
import { checkPolicy } from '@/router/individual/_insurance';

export default {
	path: '/home/insurance',
	name: 'insurance',
	redirect: { name: 'myInsurances' },
	meta: {
		title: 'Bireysel Emeklilik',
		layout: 'default'
	},
	beforeEnter: multiguard([checkAuth, checkBankType]),
	component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/insurance/Home.vue'),
	children: [
		{
			path: 'my-insurances',
			name: 'myInsurances',
			meta: {
				title: 'Bireysel Emeklilik - Sözleşmelerim',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/insurance/my-insurances/Home.vue'),
		},
		{
			path: 'detail/:policy',
			name: 'insuranceDetail',
			redirect: { name: 'insuranceDetailSummary' },
			meta: {
				title: 'Poliçe Detay',
				layout: 'default'
			},
			beforeEnter: multiguard([checkPolicy]),
			component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/insurance/detail/Home.vue'),
			children: [
				{
					path: 'summary',
					name: 'insuranceDetailSummary',
					meta: {
						title: 'Poliçe Özeti',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/insurance/detail/summary/Home.vue'),
				},
				{
					path: 'collateral-information',
					name: 'insuranceCollateralInformation',
					redirect: { name: 'collateralStatus' },
					meta: {
						title: 'Teminat Bilgileri',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/insurance/detail/collateral/Home.vue'),
					children: [
						{
							path: 'status',
							name: 'collateralStatus',
							meta: {
								title: 'Teminat Durumu',
								layout: 'default'
							},
							component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/insurance/detail/collateral/Status.vue'),
						},
						{
							path: 'hospital-visit-procedures',
							name: 'collateralHospitalVisitProcedures',
							meta: {
								title: 'Hastane Ziyaret İşlemleri',
								layout: 'default'
							},
							component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/insurance/detail/collateral/HospitalVisitProcedures.vue'),
						},
						{
							path: 'exemption-information',
							name: 'collateralExemptionInformation',
							meta: {
								title: 'Muafiyet Bilgileri',
								layout: 'default'
							},
							component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/insurance/detail/collateral/ExemptionInformation.vue'),
						},
					]
				},
				{
					path: 'refund-request',
					name: 'insuranceRefundRequest',
					meta: {
						title: 'Geri Ödeme Talebi',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/insurance/detail/refund/Home.vue'),
				},
				{
					path: 'payment-actions',
					name: 'insuranceDetailPaymentActions',
					meta: {
						title: 'Ödeme İşlemleri',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/insurance/detail/payment/Home.vue'),
				},
				{
					path: 'insurance-infos',
					name: 'insuranceDetailInsuranceInfos',
					meta: {
						title: 'Poliçe Bilgileri',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/insurance/detail/insurance/Home.vue'),
				},
				{
					path: 'dynamic-forms',
					name: 'insuranceDetailForms',
					meta: {
						title: 'Formlar',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/insurance/detail/forms/Home.vue'),
				},
			]
		},
		{
			path: 'insurance-payment/:policy',
			name: 'insurancePayment',
			meta: {
				title: 'Prim Öde',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/insurance/detail/payment/Payment.vue'),
		},
		{
			path: 'contracted-health-institutions',
			name: 'contractedHealthInstitutions',
			meta: {
				title: 'Anlaşmalı Sağlık Kuruluşları',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/insurance/ContractedHealthInstitutions.vue'),
		},
		{
			path: 'calculation-tools',
			name: 'insuranceCalculationTools',
			redirect: { name: 'paidEmployee' },
			meta: {
				title: 'Bireysel Emeklilik - Hesaplama Araçları',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/insurance/calculation-tools/Home.vue'),
			children: [
				{
					path: 'paid-employee',
					name: 'paidEmployee',
					meta: {
						title: 'Ücretli Çalışan',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/insurance/calculation-tools/PaidEmployee.vue'),
				},
				{
					path: 'self-employed',
					name: 'selfEmployed',
					meta: {
						title: 'Serbest Meslek Sahipleri',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/insurance/calculation-tools/SelfEmployed.vue'),
				}
			]
		},
		{
			path: 'past-insurance',
			name: 'pastInsurance',
			meta: {
				title: 'Geçmiş Poliçelerim',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/insurance/pastInsurance.vue'),
		},
		{
			path: 'new-refund-request/:policy',
			name: 'newRefund',
			meta: {
				title: 'Yeni Talep Oluştur',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/insurance/detail/refund/New.vue'),
		},
	]
}